/*========================================
# cs-featured collection SPでのみスライダー
========================================*/

document.addEventListener('DOMContentLoaded', function () {
  const splideSelectors = document.querySelectorAll('.cs-collection-slider__splide');
  
  splideSelectors.forEach(function (slider) {
    let splideInstance;

    const mountSplide = () => {
      splideInstance = new Splide(slider, {
        type: 'slide',
        perPage: 1,
        focus: 'center',
        arrows: true,
        pagination: false,
        breakpoints: {
          1025: {
            destroy: true, // PCサイズでは自動的に破棄
          }
        }
      });
      splideInstance.mount();
    };

    const handleResize = () => {
      if (window.innerWidth < 1025) {
        if (!slider.classList.contains('is-active')) {
          mountSplide();
        }
      } else {
        if (splideInstance && typeof splideInstance.destroy === 'function') {
          splideInstance.destroy();
        }
      }
    };

    handleResize(); // 初回実行
    window.addEventListener('resize', handleResize); // リサイズにも対応
  });
});


/*========================================
# 店舗情報 サムネイル連動スライダー
========================================*/

document.addEventListener('DOMContentLoaded', function () {
  const sliderBlocks = document.querySelectorAll('.slider-block');

  sliderBlocks.forEach(function (block) {
    const id = block.getAttribute('data-slider-id');
    const main = block.querySelector('.store-slider');
    const thumb = block.querySelector('.splide-thumb');

    const thumbSplide = new Splide(thumb, {
      fixedWidth: 120,
      fixedHeight: 80,
      isNavigation: true,
      pagination: false,
      arrows: false,
      breakpoints: {
        768: {
          fixedWidth: 80,
          fixedHeight: 60,
        }
      }
    });

    const mainSplide = new Splide(main, {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    mainSplide.sync(thumbSplide);
    thumbSplide.mount();
    mainSplide.mount();
  });
});



/*========================================
# 店舗情報タブ
========================================*/
document.addEventListener("DOMContentLoaded", function() {
    const tabs = document.querySelectorAll(".store_content_handling_tabs li a"); // a要素を対象
    const contents = document.querySelectorAll(".store_content_handling_block");

    tabs.forEach(tab => {
        tab.addEventListener("click", function(event) {
            event.preventDefault(); // **aタグのデフォルト動作を防止**
            
            // タブの親要素（li）を取得
            const parentLi = this.parentElement;
            
            // すべてのタブから 'tabon' クラスを削除
            document.querySelectorAll(".store_content_handling_tabs li").forEach(t => t.classList.remove("tabon"));
            
            // クリックしたタブに 'tabon' クラスを追加
            parentLi.classList.add("tabon");

            // すべてのコンテンツを非表示
            contents.forEach(content => {
                content.classList.remove("active");
            });

            // クリックしたタブの href のIDを取得し、その要素を表示
            const targetId = this.getAttribute("href").substring(1);
            const targetContent = document.getElementById(targetId);

            if (targetContent) {
                targetContent.classList.add("active");
                
                // **タブ切り替え時にアニメーションを発火させない**
                targetContent.classList.add("cc-animate-init", "cc-animate-in");
            }
        });
    });
});


/*========================================
# 特設ページアニメーション
========================================*/
document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('.show');

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const triggerPoint = scrollY + (windowHeight * 0.8);

    targets.forEach(el => {
      const elTop = el.getBoundingClientRect().top + scrollY;

      if (elTop < triggerPoint) {
        el.style.opacity = '1';
        el.style.transform = 'translate(0, 0)';
        el.style.transition = 'all 1s ease-out';
      }
    });
  };

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('load', handleScroll);
});

/*========================================
# 特設ページ画像カルーセル
========================================*/
document.addEventListener('DOMContentLoaded', function () {
  const splides = document.querySelectorAll('.splide.lookbook-slider'); 
  splides.forEach( slide => {
    new Splide(slide , {
      type: 'loop',
      perPage: 2,
      focus: 'center',
      gap: '0',
      arrows: false,
      pagination: true,
      autoplay: true,
      interval: 5000,
      speed: 2000,
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        768: {
          perPage: 1,
          focus: 'center',
          gap: '0', // スマホで隣の画像を見せない
        }
      }
    }).mount();    
  });
});

